import type { AxiosInstance } from "axios";
import {
  EventIdPublic,
  type UserIdPublic,
} from "@shared/schemas/branded-id.schemas";
import type { BroadcastHandoffResult } from "@shared/schemas/handoff-broadcast-input.schemas";

export function createHandoffBroadcastApi(apiClient: AxiosInstance) {
  return {
    async trigger(
      eventIdPublic: EventIdPublic,
      contact: string,
      recipientUserIds?: readonly UserIdPublic[],
    ): Promise<BroadcastHandoffResult> {
      const body =
        recipientUserIds === undefined
          ? { contact }
          : { contact, recipientUserIds };
      const response = await apiClient.post<BroadcastHandoffResult>(
        `/api/v1/admin/events/${encodeURIComponent(EventIdPublic.unwrap(eventIdPublic))}/notifications/handoff-broadcast`,
        body,
      );
      return response.data;
    },
  };
}
